<template>
  <div>
    <b-card>
      <div class="organism-server_header card-padding">
        <span class="header__label">Server Management</span>
        <atom-button
          v-if="hasUpdatePermission"
          buttonId="create-new-server"
          buttonStyle="border"
          :isDisable="!currentVeeamId || !getVeeamStatus"
          @click="clickAddServer"
        >
          <div class="d-flex d-md-none">Add</div>
          <div class="d-none d-md-flex">Add New Server</div>
        </atom-button>
      </div>
      <div class="filter-container card-padding pt-0 pb-3">
        <div class="row mt-0">
          <div
            class="col-12 col-md-4 mb-1 mb-md-0 d-flex justify-content-between"
          >
            <atom-input
              v-model="filterList.ip"
              title="IP Address"
              placeholder="IP Address"
              :isDisable="!currentVeeamId"
            ></atom-input>
          </div>
          <div
            class="col-12 col-md-5 mb-1 mb-md-0 d-flex justify-content-between"
          >
            <atom-select
              v-model="filterList.type"
              title="Type"
              placeholder="Type"
              :isClearable="true"
              :isAppendToBody="false"
              :isEnableProper="false"
              :isDisable="!currentVeeamId"
              :option="typeList"
            ></atom-select>
            <div class="d-flex align-items-end">
              <atom-button
                buttonId="button-search"
                iconLeft="SearchIcon"
                @click="clickButtonSearch"
                :isDisable="!currentVeeamId || !getVeeamStatus"
                class="search__button ml-2"
              ></atom-button>
              <div
                class="reset-filter-button ml-1"
                :class="{ 'disabled-button': !currentVeeamId }"
                @click="clickButtonClearFilter"
              >
                <span>Reset</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-12">
          <b-table
            sticky-header
            responsive
            :items="items"
            :fields="hasUpdatePermission ? fields : fields.filter(field => field.key !== 'deleteIcon')"
            :hover="true"
            @row-clicked="selectRow"
          >
            <template #cell(ip)="data"
              ><div>{{ data.value }}</div></template
            >
            <template #cell(type)="data"
              ><div>{{ data.value }}</div></template
            >
            <template #cell(description)="data"
              ><div>{{ data.value }}</div></template
            >
            <template #cell(creationTime)="data">
              <div>{{ data.value.date }}</div>
              <div class="sub-header">{{ data.value.time }}</div></template
            >
            <template #cell(deleteIcon)="data">
              <div :id="'button-delete-server' + data.item.id">
                <atom-button
                  buttonId="button-delete"
                  iconLeft="Trash2Icon"
                  buttonStyle="flat"
                  buttonColor="secondary"
                  :isDisable="serverBindingIpList.includes(data.item.ip)"
                  @click="clickDeleteServer(data)"
                ></atom-button>
              </div>
              <b-tooltip
                v-if="serverBindingIpList.includes(data.item.ip)"
                :target="'button-delete-server' + data.item.id"
                placement="left"
                boundary="window"
                variant="danger"
              >
                Server is used for Veeam repository and can't be delete
              </b-tooltip></template
            ></b-table
          >
        </div>
        <div
          v-if="!currentVeeamId"
          class="w-100 d-flex flex-column justify-content-center align-items-center p-4"
        >
          <feather-icon
            icon="CloudOffIcon"
            class="empty-data__icon"
          ></feather-icon>
          <label class="empty-data__text--title">No Server</label>
          <label v-if="!currentVeeamId" class="empty-data__text--body"
            >Please Select Veeam</label
          >
        </div>
      </div>
      <div class="row card-padding">
        <div class="col-6">Showing {{ items.length }} entries</div>
        <div v-if="currentVeeamId" class="col-6 d-flex justify-content-end">
          <div
            v-if="filterList.totalCount"
            class="col-6 d-flex justify-content-end"
          >
            <b-pagination
              v-model="filterList.currentPage"
              :total-rows="filterList.totalCount"
              :per-page="perPage"
              size="sm"
              class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>
      <section name="add-server">
        <molecule-modal-dialog
          modalId="add-server"
          :isTextCenter="true"
          buttonTextLeft="Add Server"
          textTitle="Add New Server"
          :isSlotBody="true"
          :isCloseOnBackDrop="false"
          :isDisableButtonLeft="isErrorValidateServer"
          @clickButtonLeft="clickConfirmAddServer"
          ><template #body
            ><div class="w-100">
              <div class="row mt-0">
                <div class="col-12 col-md-6 mt-2">
                  <atom-input
                    v-model="server.ip"
                    title="IP Address"
                    placeholder="IP Address"
                    :isAsterisk="true"
                    :isError="isErrorIp"
                    :errorMessage="errorMessageForIp"
                  ></atom-input>
                </div>
                <div class="col-12 col-md-6 mt-2 pl-md-0">
                  <atom-select
                    v-model="server.type"
                    title="Type"
                    placeholder="Type"
                    label="type"
                    :isAsterisk="true"
                    :isError="isErrorType"
                    :isClearable="true"
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    errorMessage="Type is required"
                    :option="typeList"
                  ></atom-select>
                </div>
                <div class="col-12 mt-2 d-flex justify-content-between">
                  <atom-select
                    v-model="server.credential"
                    title="Credential"
                    placeholder="Credential"
                    label="label"
                    :isAsterisk="true"
                    :isError="isErrorCredential"
                    :isClearable="true"
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    :option="credentialList"
                    errorMessage="Credential is required"
                  ></atom-select>
                  <atom-button
                    buttonId="button-add-credential"
                    iconLeft="PlusIcon"
                    @click="clickAddCredential"
                    class="add__button ml-2"
                  ></atom-button>
                </div>
                <div class="col-12 mt-2">
                  <atom-text-area
                    v-model="server.description"
                    title="Description"
                    placeholder="Description"
                    :rows="3"
                    :isAsterisk="true"
                    :isError="isErrorDescription"
                    errorMessage="Description is required"
                  ></atom-text-area>
                </div>
              </div></div></template
        ></molecule-modal-dialog>
      </section>

      <section name="edit-server">
        <molecule-modal-dialog
          modalId="edit-server"
          :isTextCenter="true"
          buttonTextLeft="Save Changes"
          textTitle="Server Detial"
          :isSlotBody="true"
          :isCloseOnBackDrop="false"
          :isDisableButtonLeft="
            isErrorValidateEditServer || isInvalidIpV4(server.ip)
          "
          :isButtonLeft="hasUpdatePermission"
          :isButtonRight="hasUpdatePermission"
          @clickButtonLeft="clickConfirmEditServer"
          ><template #body
            ><div class="w-100">
              <div class="row mt-0">
                <div class="col-12 col-md-6 mt-2">
                  <atom-input
                    v-model="server.ip"
                    title="IP Address"
                    placeholder="IP Address"
                    :isDisable="true"
                    :isError="isErrorIp"
                    :errorMessage="errorMessageForIp"
                  ></atom-input>
                </div>
                <div class="col-12 col-md-6 mt-2 pl-md-0">
                  <atom-select
                    v-model="server.type"
                    title="Type"
                    placeholder="Type"
                    :isAsterisk="false"
                    :isDisable="true"
                    :isError="isErrorType"
                    :isClearable="
                      isErrorValidateEditServer || isInvalidIpV4(server.ip)
                    "
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    errorMessage="Type is required"
                    :option="typeList"
                  ></atom-select>
                </div>
                <div class="col-12 mt-2 d-flex justify-content-between">
                  <atom-select
                    v-model="server.credential"
                    title="Credential"
                    placeholder="Credential"
                    label="label"
                    :isAsterisk="true && !isInvalidIpV4(server.ip)"
                    :isClearable="true && hasUpdatePermission"
                    :isDisable="isInvalidIpV4(server.ip) || !hasUpdatePermission"
                    :isAppendToBody="false"
                    :isEnableProper="false"
                    :option="credentialList"
                  ></atom-select>
                  <atom-button
                    v-if="hasUpdatePermission"
                    buttonId="button-add-credential"
                    iconLeft="PlusIcon"
                    @click="clickAddCredential('Edit')"
                    class="add__button ml-2"
                  ></atom-button>
                </div>
                <div class="col-12 mt-2">
                  <atom-text-area
                    v-model="server.description"
                    title="Description"
                    placeholder="Description"
                    :isAsterisk="true && !isInvalidIpV4(server.ip)"
                    :isDisable="isInvalidIpV4(server.ip) || !hasUpdatePermission"
                    :rows="3"
                    :isError="isErrorDescription"
                    errorMessage="Description is required"
                  ></atom-text-area>
                </div>
                <div v-if="isInvalidIpV4(server.ip)" class="col-12 mt-1">
                  <span class="text-danger">* </span>Can't edit the main Veeam
                  server
                </div>
              </div>
            </div></template
          ></molecule-modal-dialog
        >
      </section>

      <section name="delete-server">
        <molecule-modal-dialog
          modalId="delete-server"
          :isTextCenter="true"
          icon="AlertCircleIcon"
          textTitle="Do you want to delete?"
          buttonTextLeft="Delete"
          buttonColorLeft="danger"
          :isDisableButtonLeft="false"
          :isSlotBody="true"
          @clickButtonLeft="confirmDelete"
          ><template #body>
            <div class="w-70 ml-0 pl-3 pl-sm-5 ml-sm-5">
              <div>
                <label class="width-50px">server:</label>
                <b>{{ deleteServer.ip }}</b>
              </div>
            </div>
          </template>
        </molecule-modal-dialog>
      </section>

      <section name="create-credential">
        <molecule-modal-dialog
          modalId="create-credential"
          :isTextCenter="true"
          buttonTextLeft="Create Credential"
          textTitle="Create Credential"
          :isSlotBody="true"
          :isCloseOnBackDrop="false"
          :isDisableButtonLeft="isErrorValidateCredential"
          :isShowXIcon="false"
          @clickButtonLeft="clickConfirmCreateCredential"
          @clickButtonRight="clickCancelCreateCredential"
          ><template #body>
            <div class="row">
              <div class="col-12 col-md-8 mt-2">
                <atom-input
                  v-model="credential.username"
                  title="Username"
                  placeholder="Username"
                  :isAsterisk="true"
                  :isError="isErrorCredentialUsername"
                  errorMessage="Username is required"
                ></atom-input>
              </div>
              <div class="col-12 col-md-4 mt-2 pl-md-0">
                <atom-select
                  v-model="credential.type"
                  title="Type"
                  placeholder="Type"
                  label="type"
                  :isAsterisk="true"
                  :isClearable="false"
                  :isAppendToBody="false"
                  :isEnableProper="false"
                  :option="typeCredentialList"
                  :isError="isErrorCredentialType"
                  errorMessage="Type is required"
                ></atom-select>
              </div>
              <div class="col-12 mt-2">
                <atom-input
                  v-model="credential.password"
                  title="Password"
                  placeholder="Password"
                  type="password"
                  :isAsterisk="true"
                  :isError="isErrorCredentialPassword"
                  errorMessage="Password is required"
                ></atom-input>
              </div>
              <div class="col-12 mt-2">
                <atom-text-area
                  v-model="credential.description"
                  title="Description"
                  placeholder="Description"
                  :rows="3"
                  :isAsterisk="true"
                  :isError="isErrorCredentialDescription"
                  errorMessage="Description is required"
                ></atom-text-area>
              </div></div></template
        ></molecule-modal-dialog>
      </section>
    </b-card>
  </div>
</template>

<script>
import { BCard, BTable, BPagination, BTooltip } from "bootstrap-vue"
import AtomButton from "@/components/atoms/AtomButton.vue"
import AtomInput from "@/components/atoms/AtomInput.vue"
import AtomTextArea from "@/components/atoms/AtomTextArea.vue"
import AtomSelect from "@/components/atoms/AtomSelect.vue"
import MoleculeModalDialog from "@/components/molecules/MoleculeModalDialog.vue"
import mixinsValidator from "@/mixins/mixinsValidator"
import { mapGetters } from "vuex"
import { PermissionUser } from "@/constants/permission-user"
import mixinsUser from "@/mixins/mixinsUser"

export default {
  name: "OrganismServerManagement",
  components: {
    BCard,
    BTable,
    BPagination,
    BTooltip,
    AtomButton,
    AtomInput,
    AtomTextArea,
    AtomSelect,
    MoleculeModalDialog,
  },
  props: {
    filterList: {
      required: true,
      type: Object,
    },
    currentVeeamId: {
      type: String,
      required: true,
    },
    fields: {
      type: Array,
      required: false,
      default: () => [],
    },
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    credentialList: {
      type: Array,
      required: false,
      default: () => [],
    },
    serverBindingIpList: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  mixins: [mixinsValidator, mixinsUser],
  data() {
    return {
      isValidateTrigger: false,
      perPage: 10,
      modalEdit: false,
      server: {
        ip: "",
        type: "",
        credential: "",
        description: "",
      },
      credential: {
        username: "",
        password: "",
        type: "",
        description: "",
      },
      deleteServer: {
        id: "",
        ip: "",
      },
      typeList: ["Windows", "Linux", "Virtual Machine"],
      typeCredentialList: ["Standard", "Linux"],
    }
  },
  computed: {
    ...mapGetters("app", ["getVeeamStatus"]),

    hasUpdatePermission() {
      return this.hasPermission(PermissionUser.BMM.SERVER_MANAGEMENT_WRITE)
    },

    isErrorIp() {
      return this.isValidateTrigger ? this.isInvalidIpV4(this.server.ip) : false
    },
    isErrorType() {
      return this.isValidateTrigger
        ? this.isEmptyObject(this.server.type)
        : false
    },
    isErrorPort() {
      return this.isValidateTrigger
        ? this.isNotNumeric(this.server.port)
        : false
    },
    isErrorCredential() {
      return this.isValidateTrigger
        ? this.isEmptyObject(this.server.credential)
        : false
    },
    isErrorDescription() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.server.description)
        : false
    },
    errorMessageForPort() {
      if (this.server.port === "") return "Port is required"
      else {
        return "Port should be a number"
      }
    },
    isErrorCredentialUsername() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.credential.username)
        : false
    },
    isErrorCredentialPassword() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.credential.password)
        : false
    },
    isErrorCredentialType() {
      return this.isValidateTrigger
        ? this.isEmptyObject(this.credential.type)
        : false
    },
    isErrorCredentialDescription() {
      return this.isValidateTrigger
        ? this.isEmptyString(this.credential.description)
        : false
    },
    isErrorValidateServer() {
      return (
        this.isErrorIp ||
        this.isErrorType ||
        this.isErrorCredential ||
        this.isErrorDescription
      )
    },
    isErrorValidateEditServer() {
      return this.isErrorIp || this.isErrorType || this.isErrorDescription
    },
    isErrorValidateCredential() {
      return (
        this.isErrorCredentialUsername ||
        this.isErrorCredentialType ||
        this.isErrorCredentialPassword ||
        this.isErrorCredentialDescription
      )
    },
    errorMessageForIp() {
      if (this.isEmptyString(this.server.ip)) return "Ip is required"
      else {
        return "Invalid IP Address"
      }
    },
  },
  watch: {
    "filterList.currentPage": {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit("onUpdateCurrentPage", this.filterList)
        }
      },
    },
  },
  methods: {
    clickButtonSearch() {
      this.$emit("onUpdateFilterData", this.filterList)
    },
    clickButtonClearFilter() {
      if (this.currentVeeamId) {
        this.$emit("onSetDefaultFilterData")
      }
    },
    selectRow(row) {
      this.server.id = row.id
      this.server.ip = row.ip
      this.server.type = row.type
      this.server.credential = this.credentialList.find(
        (credential) => credential.id === row.credentialsId
      )
      this.server.description = row.description
      this.openModal("edit-server")
    },
    clickAddServer() {
      this.clearServer()
      this.openModal("add-server")
    },
    clickConfirmAddServer() {
      this.isValidateTrigger = true
      if (!this.isErrorValidateServer) {
        let addServer = {
          name: this.server.ip,
          description: this.server.description,
          type: this.mapTypeToApiFormat(this.server.type),
          credentialsId: this.server.credential.id,
          networkSettings: null,
        }
        if (addServer.type === "WindowsHost") {
          addServer.networkSettings = {
            components: [
              {
                componentName: "DeployerSvc",
                port: 6160,
              },
            ],
          }
        }
        this.$emit("addServer", addServer)
        this.closeModal()
      }
    },
    clickConfirmEditServer() {
      this.isValidateTrigger = true
      if (!this.isErrorValidateEditServer) {
        let editServer = {
          id: this.server.id,
          name: this.server.ip,
          description: this.server.description,
          type: this.mapTypeToApiFormat(this.server.type),
          credentialsId: this.server.credential.id,
          networkSettings: null,
        }
        if (editServer.type === "WindowsHost") {
          editServer.networkSettings = {
            components: [
              {
                componentName: "DeployerSvc",
                port: 6160,
              },
            ],
          }
        }
        this.$emit("editServer", editServer)
        this.closeModal()
      }
    },
    clickDeleteServer(row) {
      this.deleteServer.id = row.item.id
      this.deleteServer.ip = row.item.ip
      this.openModal("delete-server")
    },
    confirmDelete() {
      this.$emit("deleteServer", this.deleteServer.id)
      this.closeModal()
    },
    openModal(id) {
      if (this.modalId) this.closeModal()
      this.modalId = id
      this.$bvModal.show(this.modalId)
    },
    // close modal
    closeModal() {
      this.$bvModal.hide(this.modalId)
      this.modalId = null
      this.isValidateTrigger = false
    },
    clearServer() {
      this.server.ip = ""
      this.server.type = ""
      this.server.credential = ""
      this.server.description = ""
    },
    clickAddCredential(edit) {
      if (edit == "Edit") {
        this.modalEdit = true
      } else {
        this.modalEdit = false
      }
      this.openModal("create-credential")
    },
    clickConfirmCreateCredential() {
      this.isValidateTrigger = true
      if (!this.isErrorValidateCredential) {
        const addCredential = {
          username: this.credential.username,
          type: this.credential.type,
          password: this.credential.password,
          description: this.credential.description,
        }
        this.$emit("addCredential", addCredential)
        this.closeModal()
        this.clearCredential()
        this.openModal("add-server")
      }
    },
    clickCancelCreateCredential() {
      this.clearCredential()
      if (this.modalEdit == false) {
        this.openModal("add-server")
      } else {
        this.openModal("edit-server")
      }
    },
    clearCredential() {
      this.credential.username = ""
      this.credential.password = ""
      this.credential.type = ""
      this.credential.description = ""
    },
    mapTypeToApiFormat(type) {
      let newType = ""
      if (type == "Virtual Machine") newType = "ViHost"
      else if (type === "Windows") newType = "WindowsHost"
      else if (type === "Linux") newType = "LinuxHost"
      return newType
    },
  },
}
</script>

<style lang="scss" scoped>
.organism-server_header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-padding {
  padding: 1.5rem;
}
.card-body {
  padding: 0;
}

.header__label {
  font-weight: 500;
  font-size: 18px;
  color: #5e5873;
}

.filter-container {
  border-bottom: 1px solid #e9ecef;
}

.search__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}
.add__button {
  margin-top: 23px;
  margin-right: 0;
  height: fit-content;
}

.sub-header {
  font-weight: 400;
  font-size: 12px;
  color: #b9b9c3;
}

.width-50px {
  width: 50px;
}

.empty-data__icon {
  width: 100px;
  height: 100px;
}

.empty-data__text--title {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
  margin-top: 20px;
}
.empty-data__text--body {
  color: #b9b9c3;
  font-size: 14px;
  margin-top: 10px;
}

.reset-filter-button {
  color: #b9b9c3;
  margin-bottom: 8px;
  text-decoration: underline;
  &:not(.disabled-button):hover {
    cursor: pointer;
    color: #7367f0;
  }
}
</style>
